import { ReactNode } from "react";
import { SEOBreadcrumbs } from "./SEOBreadcrumbs";

interface PageLayoutProps {
  children: ReactNode;
}

export function PageLayout({ children }: PageLayoutProps) {
  return (
    <>
      <SEOBreadcrumbs />
      {children}
    </>
  );
}